import LocalizationApp from './localization/localization-app';
import './App.css';

function App() {
  return (
    <div className="App">
      <LocalizationApp />
    </div>
  );
}

export default App;
